import * as Animate from "react-reveal";
import Avatar1 from "../../../assets/images/png/talent-leader.webp";
import Avatar2 from "../../../assets/images/png/mba/mba-leader-woman-v1.png";
import Avatar3 from "../../../assets/images/png/bankole-adesina-v1.png";
import Avatar4 from "../../../assets/images/png/mba/mba-leader-man-v1.png";
import Avatar5 from "../../../assets/images/png/mba/mba-leader-hijab-v1.png";

const steps = [
  {
    number: "01",
    title: "Learn",
    desc:
      "Professionals develop relevant technology and business capabilities.",
    avatar: Avatar1,
  },
  {
    number: "02",
    title: "Practice",
    desc: "They build projects and demonstrate practical ability.",
    avatar: Avatar2,
  },
  {
    number: "03",
    title: "Assess",
    desc: "Skills, communication, judgement and readiness are evaluated.",
    avatar: Avatar3,
  },
  {
    number: "04",
    title: "Talent Network",
    desc: "Qualified professionals become accessible to employers.",
    avatar: Avatar4,
  },
  {
    number: "05",
    title: "Hire",
    desc: "Companies access talent based on their actual needs.",
    avatar: Avatar5,
    dark: true,
  },
];

const HireModelsSection = () => {
  return (
    <section
      className="bg-hire-tint-blue py-16 md:py-20 lg:py-24 px-4"
      id="models"
    >
      <div className="container mx-auto">
        <Animate.Fade bottom>
          <p className="flex items-center font-poppins gap-3 text-primary text-sm font-extrabold tracking-widest uppercase mb-6">
            <span className="w-8 h-1 rounded-full bg-secondary inline-block"></span>
            The Utiva talent engine
          </p>
        </Animate.Fade>

        <Animate.Fade bottom>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-poppins leading-tight font-black mb-6 max-w-3xl tracking-[-0.03em]">
            <span className="text-default">
              We Don&apos;t Wait for Great Talent to Appear.
            </span>{" "}
            <span className="text-primary">We Build the Pipeline.</span>
          </h2>
        </Animate.Fade>
        <Animate.Fade bottom>
          <p className="text-gray text-base md:text-lg font-poppins leading-relaxed max-w-2xl mb-12 lg:mb-14">
            Utiva operates the ecosystem that develops ability, proves readiness
            and makes qualified professionals accessible to employers.
          </p>
        </Animate.Fade>

        <Animate.Fade bottom>
          <div className="relative bg-white rounded-3xl overflow-hidden flex flex-col lg:flex-row shadow-course-card">
            {steps.map((step, index) => (
              <article
                key={step.number}
                className={`relative flex-1 flex flex-col p-6 ${
                  index !== steps.length - 1
                    ? "border-b lg:border-b-0 lg:border-r border-hire-line"
                    : ""
                } ${step.dark ? "bg-primary text-white" : "bg-white"}`}
                style={{ minHeight: "250px" }}
              >
                {index !== 0 && (
                  <span
                    className="hidden lg:grid absolute z-10 top-6 -left-4 w-8 h-8 rounded-full bg-secondary text-primary place-items-center text-sm"
                    aria-hidden="true"
                  >
                    →
                  </span>
                )}

                <span
                  className={`font-poppins text-sm font-extrabold ${
                    step.dark ? "text-secondary" : "text-[#956000]"
                  }`}
                >
                  {step.number}
                </span>
                <img
                  src={step.avatar}
                  alt=""
                  className="w-14 h-14 rounded-full object-cover border-2 border-white shadow-course-card mt-8"
                />
                <div className="mt-auto pt-6">
                  <h3
                    className={`font-poppins font-bold text-2xl mb-2.5 ${
                      step.dark ? "text-white" : "text-primary"
                    }`}
                  >
                    {step.title}
                  </h3>
                  <p
                    className={`font-poppins text-sm leading-relaxed m-0 ${
                      step.dark ? "text-indigo-100" : "text-gray"
                    }`}
                  >
                    {step.desc}
                  </p>
                </div>
              </article>
            ))}
          </div>
        </Animate.Fade>

        <Animate.Fade bottom>
          <div className="bg-white rounded-2xl grid grid-cols-1 sm:grid-cols-3 gap-4 text-center mt-4 px-6 py-6 md:px-8">
            <strong className="text-primary font-poppins text-base">
              We Build the Talent Pipeline.
            </strong>
            <span className="text-default font-poppins font-bold text-base">
              You Build the Team.
            </span>
            <b className="text-[#956000] font-poppins font-bold text-base">
              Utiva Runs the Infrastructure.
            </b>
          </div>
        </Animate.Fade>
      </div>
    </section>
  );
};

export default HireModelsSection;
